import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'tabContent']

  toggle(event) {
    const tabId = event.currentTarget.dataset.tabId
    this.handleTabsStyle(tabId)
    this.handleTabsDisplay(tabId)
  }

  handleTabsStyle(tabId) {
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabId === tabId) {
        tab.classList.add('bg-purple-200', 'font-medium')
        tab.classList.remove('bg-neutral-000', 'font-normal')
      } else {
        tab.classList.remove('bg-purple-200', 'font-medium')
        tab.classList.add('bg-neutral-000', 'font-normal')
      }
    })
  }

  handleTabsDisplay(tabId) {
    this.tabContentTargets.forEach(tabContent => {
      if (tabContent.dataset.tabId === tabId) {
        tabContent.classList.remove('hidden')
      } else {
        tabContent.classList.add('hidden')
      }
    })
  }
}
